import {config, library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText} from '@fortawesome/vue-fontawesome'
import {
    faAngleDown, faArrowRight, faBars, faCalendar, faCamera, faCaretSquareDown, faCaretSquareUp, faCheck, 
    faChevronDown, faChevronLeft, faChevronRight, faCircle, faCircleInfo, faCircleNotch, faExclamationTriangle, 
    faExpand, faEyeSlash, faFileDownload, faGrip, faInfoCircle, faListUl, faLocationCrosshairs, faMap, faMapLocationDot, 
    faNewspaper, faPaperPlane, faPen, faPlus, faPrint, faQuestionCircle, faSearch, faTh, faTimes, faTrash
} from '@fortawesome/free-solid-svg-icons'
import {
    faCalendar as faCalendarRegular
} from '@fortawesome/free-regular-svg-icons'

// Explicit list instead of library.add(fas/far/fab): the three packs are 2051 icons and 1.31 MB of
// path data, of which this app renders 33. Every name below was resolved against the installed
// packs. An icon that is not registered renders empty without an error, so add new ones here as you
// use them rather than reaching back for a whole pack.
const icons = [
    faAngleDown, faArrowRight, faBars, faCalendar, faCamera, faCaretSquareDown, faCaretSquareUp, faCheck, 
    faChevronDown, faChevronLeft, faChevronRight, faCircle, faCircleInfo, faCircleNotch, faExclamationTriangle, 
    faExpand, faEyeSlash, faFileDownload, faGrip, faInfoCircle, faListUl, faLocationCrosshairs, faMap, faMapLocationDot, 
    faNewspaper, faPaperPlane, faPen, faPlus, faPrint, faQuestionCircle, faSearch, faTh, faTimes, faTrash, faCalendarRegular,
]

// This is important, we are going to let Nuxt worry about the CSS
config.autoAddCss = false

library.add(...icons)

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.component('font-awesome-icon', FontAwesomeIcon, {})
    nuxtApp.vueApp.component('font-awesome-layers', FontAwesomeLayers, {})
    nuxtApp.vueApp.component('font-awesome-layers-text', FontAwesomeLayersText, {})
})
